module.exports = __webpack_public_path__ + "img/ime_icon_active.69164548.svg";